(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2202],{

/***/ 32223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/theatres/[slug]/[playSlug]",
      function () {
        return __webpack_require__(91490);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70082);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56168);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var _enums_playlistType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54071);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22135);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81962);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3245);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20010);













var CategorySection = function(param) {
    var title = param.title, plays = param.plays, theater = param.theater, playlistType = param.playlistType, id = param.id, moreHref = param.moreHref, _showResume = param.showResume, showResume = _showResume === void 0 ? false : _showResume, _mediumThumbs = param.mediumThumbs, mediumThumbs = _mediumThumbs === void 0 ? false : _mediumThumbs, _largeThumbs = param.largeThumbs, largeThumbs = _largeThumbs === void 0 ? false : _largeThumbs, _centered = param.centered, centered = _centered === void 0 ? false : _centered;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Common */ .l.Common).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_2__/* .useLang */ .J)().locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), elementTop = ref1[0], setElementTop = ref1[1];
    var query = {};
    if (playlistType !== _enums_playlistType__WEBPACK_IMPORTED_MODULE_6__/* .PlaylistType.Theater */ .e.Theater) {
        if (id) {
            query["id"] = id;
        }
        query["type"] = playlistType;
    }
    (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useCategoryRowSwiper */ .jR)(ref, plays);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var width = 256;
        var height = 144;
        if (mediumThumbs) {
            height = 351;
        } else if (largeThumbs) {
            width = 367;
            height = 504;
        }
        return [
            width,
            height,
            height > width
        ];
    }, [
        largeThumbs,
        mediumThumbs
    ]), imageWidth = ref2[0], imageHeight = ref2[1], isImagePortrait = ref2[2];
    var cls = [
        "category-section"
    ];
    if (mediumThumbs) {
        cls.push("category-section-medium");
    } else if (largeThumbs) {
        cls.push("category-section-large");
    }
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            var ref1;
            // calculate top only once on initial render
            setElementTop(ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect().top);
        }
    }, [
        ref
    ]);
    var loadImages = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useOnScrollElement */ .Vq)(elementTop);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("category-section-bg", centered ? "centered" : null),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: cls.join(" "),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    children: [
                        title,
                        Boolean(moreHref) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            href: {
                                pathname: moreHref
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: t("more")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: ref,
                    className: "scroll-wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "play-list swiper-wrapper",
                            children: plays === null || plays === void 0 ? void 0 : plays.map(function(play) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("swiper-slide", showResume ? "resume" : "", play.is_original ? "original" : null),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            href: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.play */ .xm.play(play, locale),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "category-image",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            loadImmediately: loadImages,
                                                            placeholderClass: "img-placeholder-category-playlist",
                                                            src: play.poster_url,
                                                            alt: play.title,
                                                            width: imageWidth,
                                                            height: imageHeight,
                                                            quality: 90,
                                                            usePlaceholder: true
                                                        })
                                                    }),
                                                    play.state === _typings_api__WEBPACK_IMPORTED_MODULE_9__/* .PlayState.PROMOTED */ .QT.PROMOTED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "coming-soon",
                                                        children: t("coming_soon")
                                                    }) : null,
                                                    !isImagePortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .truncateTitle */ .ew)(play.title)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: theater ? theater : play.theatre.name
                                                            })
                                                        ]
                                                    }),
                                                    isImagePortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                                children: [
                                                                    play.logo_url && largeThumbs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: play.logo_url,
                                                                        alt: play.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        children: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .truncateTitle */ .ew)(play.title)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: theater ? theater : play.theatre.name
                                                            })
                                                        ]
                                                    }),
                                                    showResume && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            style: {
                                                                width: "".concat(((ref = play.video) === null || ref === void 0 ? void 0 : ref.user_progress) / ((ref1 = play.video) === null || ref1 === void 0 ? void 0 : ref1.runtime) * 100, "%")
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        showResume && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "play",
                                            title: t("common:play_btn"),
                                            onClick: function() {
                                                window.location.href = _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.watch */ .xm.watch(play, locale);
                                            }
                                        })
                                    ]
                                }, play.id);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#",
                            className: "control prev",
                            title: t("common:previous_play"),
                            children: t("common:previous_play")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#",
                            className: "control next",
                            title: t("common:next_play"),
                            children: t("common:next_play")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySection);


/***/ }),

/***/ 80584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60041);
/* harmony import */ var context_authContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13102);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70082);
/* harmony import */ var context_popupContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30785);
/* harmony import */ var enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var enums_popupType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91360);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56168);
/* harmony import */ var _PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86145);
/* harmony import */ var _PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10__);












var PlayButton = function(param) {
    var play = param.play, _longTitle = param.longTitle, longTitle = _longTitle === void 0 ? false : _longTitle, _alwaysOn = param.alwaysOn, alwaysOn = _alwaysOn === void 0 ? false : _alwaysOn;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Common */ .l.Common).t;
    var setPopup = (0,context_popupContext__WEBPACK_IMPORTED_MODULE_4__/* .usePopup */ .BF)().setPopup;
    var ref1 = (0,context_authContext__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)(), user = ref1.user, isUserLoaded = ref1.isUserLoaded;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_3__/* .useLang */ .J)().locale;
    var isComingSoon = play && (!(play === null || play === void 0 ? void 0 : play.video) || play.date_published_from && Date.now() < Date.parse(play.date_published_from));
    var popupType = enums_popupType__WEBPACK_IMPORTED_MODULE_6__/* .PopupType.BuySubscription */ .k.BuySubscription;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(null), ios15Content = ref2[0], setIos15Content = ref2[1];
    var cls = classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn btn-primary btn-play", (_PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().play), !(play && isUserLoaded || alwaysOn) ? (_PlayButton_module_scss__WEBPACK_IMPORTED_MODULE_10___default().hidden) : "", isComingSoon ? "btn-warning btn-no-events" : "");
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        if (window.navigator.userAgent.indexOf("15_0") > -1 && isUserLoaded) {
            title = t("common:open_in_mobile_app");
            link = constants_links__WEBPACK_IMPORTED_MODULE_11__/* .LINK_APP_STORE */ .c;
            setIos15Content(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: link,
                className: cls,
                tabIndex: -1,
                rel: "external",
                children: title
            }, "app"));
        }
    }, [
        isUserLoaded
    ]);
    if (ios15Content) {
        return ios15Content;
    }
    if (isComingSoon) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: cls,
            children: t("coming_soon")
        });
    }
    var title = t(longTitle ? "play_btn_long" : "play_btn");
    // no user -> login popup
    if (isUserLoaded && !user) {
        popupType = enums_popupType__WEBPACK_IMPORTED_MODULE_6__/* .PopupType.Login */ .k.Login;
    }
    // video is available
    if (play === null || play === void 0 ? void 0 : (ref = play.video) === null || ref === void 0 ? void 0 : ref.user_progress) {
        // resume play label
        if (!longTitle) {
            title = t("continue");
        } else {
            var ref3, ref4;
            title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    t("continue"),
                    "\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("continue_remaining", {
                            time: (0,helpers__WEBPACK_IMPORTED_MODULE_7__/* .sec2time */ .bp)((play === null || play === void 0 ? void 0 : (ref3 = play.video) === null || ref3 === void 0 ? void 0 : ref3.runtime) - (play === null || play === void 0 ? void 0 : (ref4 = play.video) === null || ref4 === void 0 ? void 0 : ref4.user_progress))
                        })
                    })
                ]
            });
        }
    }
    var link = play ? helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.watch */ .xm.watch(play, locale) : null;
    if (user === null || user === void 0 ? void 0 : user.isSubscriber) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: link,
            className: cls,
            tabIndex: -1,
            onMouseUp: function() {
                return window.location.href = link;
            },
            children: title
        });
    }
    var _onClickShowPopup = function(e) {
        e.preventDefault();
        setPopup(popupType);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: link,
        className: cls,
        tabIndex: -1,
        onClick: _onClickShowPopup,
        children: title
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButton);


/***/ }),

/***/ 91490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _playSlug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./components/CategorySections/CategorySection.tsx
var CategorySection = __webpack_require__(74107);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./pages/theatres/[slug]/[playSlug]/index.module.scss
var index_module = __webpack_require__(28584);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/AppLink/AppLink.tsx
var AppLink = __webpack_require__(3245);
// EXTERNAL MODULE: ./components/Popups/BasePopup.tsx
var BasePopup = __webpack_require__(73495);
;// CONCATENATED MODULE: ./components/Popups/CastPopup.tsx




function CastPopup(param) {
    var onClose = param.onClose, headline = param.headline, roles = param.roles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasePopup/* default */.Z, {
        showCloseIcon: true,
        classes: [
            "text-content",
            "list-content"
        ],
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "wrapper",
                children: roles.map(function(role) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: role.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: role.celebrities.map(function(cel) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                            href: helpers/* Permalink.celebrity */.xm.celebrity(cel),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    (0,helpers/* getCastImg */.A9)(cel),
                                                    cel.name
                                                ]
                                            })
                                        })
                                    }, cel.id);
                                })
                            })
                        ]
                    }, role.name);
                })
            })
        ]
    });
}
/* harmony default export */ var Popups_CastPopup = (CastPopup);

// EXTERNAL MODULE: ./components/buttons/PlayButton/PlayButton.tsx
var PlayButton = __webpack_require__(80584);
// EXTERNAL MODULE: ./helpers/jsx.tsx
var jsx = __webpack_require__(28808);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
// EXTERNAL MODULE: ./helpers/Analytics.ts
var Analytics = __webpack_require__(86639);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(57919);
// EXTERNAL MODULE: ./helpers/PlatformHelper.ts
var PlatformHelper = __webpack_require__(61400);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(50744);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(66564);
// EXTERNAL MODULE: ./config/routeTable.ts
var routeTable = __webpack_require__(82278);
;// CONCATENATED MODULE: ./pages/theatres/[slug]/[playSlug]/index.tsx




// @ts-ignore





















var FIRST_ROLES = [
    "original-author",
    "director",
    "actor"
];
var PerformanceDetail = function(param) {
    var play = param.play, similarGenresPlays = param.similarGenresPlays, similarCastPlays = param.similarCastPlays, moreFromTheatre = param.moreFromTheatre, translations = param.translations, countryCode = param.countryCode;
    var ref, ref1, ref2, ref3;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref4 = (0,react.useState)(false), castDialogShowed = ref4[0], setCastDialogShowed = ref4[1];
    var ref5 = (0,react.useState)(""), castListClass = ref5[0], setCastListClass = ref5[1];
    var ref6 = (0,react.useState)(2), castSectionCount = ref6[0], setCastSectionCount = ref6[1];
    var ref7 = (0,react.useState)(false), smallerHeadingCssClass = ref7[0], setSmallerHeadingCssClass = ref7[1];
    var locale = (0,langContext/* useLang */.J)().locale;
    var user = (0,context/* useAuth */.aC)().user;
    var setPopupConfig = (0,context/* usePopup */.BF)().setPopupConfig;
    var createNotification = (0,context/* useNotificationContext */.nw)().createNotification;
    var ref8 = (0,react.useState)(false), previewVisible = ref8[0], setPreviewVisible = ref8[1];
    var ref9 = (0,react.useState)(), videoDetails = ref9[0], setVideoDetails = ref9[1];
    var elH1 = (0,react.useRef)(null);
    var ref10 = (0,react.useState)(false), onWatchlist = ref10[0], setOnWatchlist = ref10[1];
    (0,react.useEffect)(function() {
        if (user && play) {
            (0,client/* getSharedApiClient */.L)().getPlayDetail(play.id).then(setVideoDetails);
        }
    }, [
        user,
        play
    ]);
    (0,react.useEffect)(function() {
        // prepare data for cast section
        var sectionCounter = 0;
        var listClassTmp = "";
        if (play) {
            var ref;
            var rolesCount = (ref = play.roles) === null || ref === void 0 ? void 0 : ref.length;
            if (rolesCount > 4) {
                listClassTmp = (index_module_default()).ommited2;
                sectionCounter = 4;
            } else if (rolesCount > 3) {
                listClassTmp = (index_module_default()).ommited3;
                sectionCounter = 4;
            } else {
                listClassTmp = (index_module_default()).ommited;
                sectionCounter = 3;
            }
            setCastSectionCount(sectionCounter);
            setCastListClass(listClassTmp);
            // update h1's font size on desktop when number of lines >= 3
            if (!PlatformHelper/* default.isMobile */.Z.isMobile) {
                var style = window.getComputedStyle(elH1.current);
                var ref1 = (0,_sliced_to_array/* default */.Z)([
                    "lineHeight",
                    "height"
                ].map(function(prop) {
                    return parseInt(style[prop], 10);
                }), 2), lineHeight = ref1[0], height = ref1[1];
                var numberOfLines = height / lineHeight;
                if (numberOfLines >= 3) {
                    setSmallerHeadingCssClass(true);
                }
            }
            if (play.watchlist_added) {
                setOnWatchlist(true);
            }
            if ( true && window.navigator.userAgent.indexOf("15_0") === -1 && (play === null || play === void 0 ? void 0 : play.preview)) {
                setPreviewVisible(true);
            }
        }
    }, [
        play,
        setPreviewVisible
    ]);
    var showMoreCast = function(e) {
        e.preventDefault();
        if ((0,helpers/* isMobileView */.lZ)()) {
            setCastListClass("");
            setCastSectionCount(1000);
        } else {
            setCastDialogShowed(true);
        }
    };
    var roles = (0,react.useMemo)(function() {
        return (0,helpers/* sortByKeys */.Rv)(play === null || play === void 0 ? void 0 : play.roles, "slug", FIRST_ROLES);
    }, [
        play
    ]);
    var isLowQuality = (0,react.useMemo)(function() {
        var ref;
        return (play === null || play === void 0 ? void 0 : (ref = play.video) === null || ref === void 0 ? void 0 : ref.flags.indexOf("LOWER_QUALITY")) > -1;
    }, [
        play === null || play === void 0 ? void 0 : play.video
    ]);
    var structuredSEOData = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var directors = (ref = roles.find(function(r) {
            return r.name === "Director";
        })) === null || ref === void 0 ? void 0 : ref.celebrities;
        var actors = (ref1 = roles.find(function(r) {
            return r.name === "Actor";
        })) === null || ref1 === void 0 ? void 0 : ref1.celebrities;
        return {
            "@context": "https://schema.org/",
            "@type": "Movie",
            duration: "PT".concat(Math.floor(((play === null || play === void 0 ? void 0 : (ref2 = play.video) === null || ref2 === void 0 ? void 0 : ref2.runtime) || 0) / 60), "M"),
            name: play.title,
            dateCreated: play.date_aired,
            productionCompany: {
                "@type": "EntertainmentBusiness",
                name: (ref3 = play.theatre) === null || ref3 === void 0 ? void 0 : ref3.name,
                image: (ref4 = play.theatre) === null || ref4 === void 0 ? void 0 : ref4.poster_url,
                url: "".concat((0,routeTable/* baseUrl */.F)(locale)).concat(helpers/* Permalink.theatre */.xm.theatre(play.theatre, locale))
            },
            director: directors === null || directors === void 0 ? void 0 : directors.map(function(p) {
                return {
                    "@type": "Person",
                    name: p.name,
                    image: p.poster_url,
                    url: "".concat((0,routeTable/* baseUrl */.F)(locale)).concat(helpers/* Permalink.celebrity */.xm.celebrity(p, locale))
                };
            }),
            actor: actors === null || actors === void 0 ? void 0 : actors.map(function(p) {
                return {
                    "@type": "Person",
                    name: p.name,
                    image: p.poster_url,
                    url: "".concat((0,routeTable/* baseUrl */.F)(locale)).concat(helpers/* Permalink.celebrity */.xm.celebrity(p, locale))
                };
            }),
            image: play.poster_url
        };
    }, [
        roles,
        play
    ]);
    var getDonatePart = (0,react.useCallback)(function(caller) {
        if (!play.theatre.donations_allowed) {
            return null;
        }
        if (caller === "mobile") {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).supportMobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).theaterLogo,
                        style: {
                            backgroundImage: "url(".concat(play === null || play === void 0 ? void 0 : (ref = play.theatre) === null || ref === void 0 ? void 0 : ref.poster_url, ")")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: translations === null || translations === void 0 ? void 0 : translations.supportTheater
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                        href: helpers/* Permalink.donateTheatre */.xm.donateTheatre(play === null || play === void 0 ? void 0 : play.theatre, locale),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: translations === null || translations === void 0 ? void 0 : translations.support
                            })
                        })
                    })
                ]
            });
        } else if (caller === "desktop") {
            var ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                href: helpers/* Permalink.donateTheatre */.xm.donateTheatre(play === null || play === void 0 ? void 0 : play.theatre, locale),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (index_module_default()).supportDesktop,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default()).theaterLogo,
                            style: {
                                backgroundImage: "url(".concat(play === null || play === void 0 ? void 0 : (ref1 = play.theatre) === null || ref1 === void 0 ? void 0 : ref1.poster_url, ")")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: translations === null || translations === void 0 ? void 0 : translations.support
                        })
                    ]
                })
            });
        } else {
            return null;
        }
    }, [
        translations
    ]);
    var watchListText = (0,react.useCallback)(function() {
        return onWatchlist ? translations === null || translations === void 0 ? void 0 : translations.onWatchList : translations === null || translations === void 0 ? void 0 : translations.watchList;
    }, [
        onWatchlist
    ]);
    var onWatchListBtn = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!onWatchlist) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 3;
                    return (0,client/* getSharedApiClient */.L)().removeFromWatchlist(play.id);
                case 3:
                    createNotification({
                        title: translations === null || translations === void 0 ? void 0 : translations.removedFromWatchList
                    });
                    setOnWatchlist(false);
                    Analytics/* default.v2_watchlistRemove */.ZP.v2_watchlistRemove(play.title, play.theatre.name);
                    _ctx.next = 13;
                    break;
                case 8:
                    _ctx.next = 10;
                    return (0,client/* getSharedApiClient */.L)().addToWatchlist(play.id);
                case 10:
                    createNotification({
                        title: translations === null || translations === void 0 ? void 0 : translations.addedToWatchList
                    });
                    Analytics/* default.v2_watchlistAdd */.ZP.v2_watchlistAdd(play.title, play.theatre.name);
                    setOnWatchlist(true);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        onWatchlist,
        createNotification,
        setOnWatchlist,
        client/* getSharedApiClient */.L
    ]);
    var lowQuality = (0,react.useCallback)(function() {
        if (!isLowQuality) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            onClick: function() {
                setPopupConfig({
                    popupType: enums/* PopupType.LowQuality */.kQ.LowQuality,
                    onClose: function() {
                        return setPopupConfig(null);
                    }
                });
            },
            href: "#",
            id: "low-quality-btn",
            className: (index_module_default()).lowQuality,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/svg/ic-info.svg",
                    alt: "i"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("play-detail:low_quality")
                })
            ]
        });
    }, [
        isLowQuality,
        setPopupConfig
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    (0,jsx/* basicSEO */.F)(t("seo:performance_title", {
                        title: play.title,
                        theatre: (ref = play.theatre) === null || ref === void 0 ? void 0 : ref.name
                    }), play.about, play.poster_url),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(structuredSEOData)
                        }
                    }),
                    i18n.locales.map(function(langLocale) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "alternate",
                            href: "".concat((0,routeTable/* baseUrl */.F)(langLocale)).concat(helpers/* Permalink.play */.xm.play(play, langLocale)),
                            hrefLang: langLocale
                        }, langLocale);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        href: "".concat((0,routeTable/* baseUrl */.F)("en")).concat(helpers/* Permalink.play */.xm.play(play, "en")),
                        hrefLang: "x-default"
                    }, "lang-default")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: classnames_default()((index_module_default()).playDetail, smallerHeadingCssClass ? (index_module_default()).smallerHeading : null),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).desktopWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).infoWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).image,
                                        style: {
                                            backgroundImage: "url(".concat((0,helpers/* imageUrl */.sQ)(play === null || play === void 0 ? void 0 : play.poster_url, 720, undefined, 70), ")")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (index_module_default()).playMeta,
                                        children: [
                                            play.is_original && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: helpers/* Permalink.dramoxOriginals */.xm.dramoxOriginals(locale),
                                                    className: (index_module_default()).original,
                                                    title: "Dramox Original",
                                                    children: "Dramox Original"
                                                })
                                            }),
                                            (play === null || play === void 0 ? void 0 : (ref1 = play.video) === null || ref1 === void 0 ? void 0 : ref1.runtime) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: (index_module_default()).time,
                                                children: (0,helpers/* sec2time */.bp)(play === null || play === void 0 ? void 0 : (ref2 = play.video) === null || ref2 === void 0 ? void 0 : ref2.runtime)
                                            }),
                                            (play === null || play === void 0 ? void 0 : play.date_aired) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (index_module_default()).premiere,
                                                children: [
                                                    translations === null || translations === void 0 ? void 0 : translations.premiere,
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: (0,helpers/* formatYear */.B3)(play === null || play === void 0 ? void 0 : play.date_aired, locale)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        ref: elH1,
                                        children: play === null || play === void 0 ? void 0 : play.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                            href: helpers/* Permalink.theatre */.xm.theatre(play === null || play === void 0 ? void 0 : play.theatre),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: play === null || play === void 0 ? void 0 : play.theatre.name
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).buttons,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayButton/* default */.Z, {
                                                play: videoDetails !== null && videoDetails !== void 0 ? videoDetails : play,
                                                longTitle: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    previewVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                        href: helpers/* Permalink.preview */.xm.preview(play, locale),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: [
                                                                "btn",
                                                                "btn-outline-info",
                                                                (index_module_default()).btnWithIcon,
                                                                (index_module_default()).trailer
                                                            ].join(" "),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: translations === null || translations === void 0 ? void 0 : translations.trailer
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        onClick: onWatchListBtn,
                                                        className: [
                                                            "btn",
                                                            "btn-outline-info",
                                                            (index_module_default()).btnWithIcon,
                                                            (index_module_default()).watchList,
                                                            onWatchlist ? (index_module_default()).checked : "", 
                                                        ].join(" "),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: watchListText()
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            getDonatePart("desktop")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).lowQualityMobile,
                                        children: lowQuality()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (index_module_default()).about,
                                        children: play === null || play === void 0 ? void 0 : play.about
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).lowQualityDesktop,
                                        children: lowQuality()
                                    }),
                                    getDonatePart("mobile"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_module_default()).genres,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    translations === null || translations === void 0 ? void 0 : translations.genres,
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (index_module_default()).tags,
                                                children: play === null || play === void 0 ? void 0 : play.genres.map(function(gnr) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                        href: {
                                                            pathname: helpers/* Permalink.genre */.xm.genre(gnr, locale),
                                                            query: {
                                                                type: enums/* PlaylistType.Genres */.eX.Genres
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: gnr.name
                                                        })
                                                    }, gnr.id);
                                                })
                                            })
                                        ]
                                    }),
                                    (play === null || play === void 0 ? void 0 : play.awards.length) && (play === null || play === void 0 ? void 0 : play.awards[0]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).masonRow,
                                        children: play === null || play === void 0 ? void 0 : (ref3 = play.awards) === null || ref3 === void 0 ? void 0 : ref3.filter(function(p) {
                                            return !!p;
                                        }).map(function(p, i) {
                                            var odd = {
                                                float: "right",
                                                clear: "right"
                                            };
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).masonCol,
                                                style: i % 2 === 0 ? null : odd,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (index_module_default()).prizes,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            children: translations === null || translations === void 0 ? void 0 : translations.awards
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: p
                                                        })
                                                    ]
                                                })
                                            }, i);
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).castWrapper,
                                children: [
                                    roles === null || roles === void 0 ? void 0 : roles.map(function(role, i) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: castSectionCount < i ? (index_module_default()).notShowed : "",
                                                    children: role.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: [
                                                        (index_module_default()).imageList,
                                                        castListClass,
                                                        castSectionCount < i ? (index_module_default()).notShowed : ""
                                                    ].join(" "),
                                                    children: role === null || role === void 0 ? void 0 : role.celebrities.map(function(celeb) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                href: helpers/* Permalink.celebrity */.xm.celebrity(celeb),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    children: [
                                                                        (0,helpers/* getCastImg */.A9)(celeb),
                                                                        celeb.name
                                                                    ]
                                                                })
                                                            })
                                                        }, celeb.id);
                                                    })
                                                })
                                            ]
                                        }, i);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#",
                                        onClick: showMoreCast,
                                        className: [
                                            (index_module_default()).more,
                                            castListClass === "" ? (index_module_default()).notShowed : ""
                                        ].join(" "),
                                        children: translations === null || translations === void 0 ? void 0 : translations.showAll
                                    }),
                                    castDialogShowed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popups_CastPopup, {
                                        headline: translations.cast,
                                        onClose: function() {
                                            setCastDialogShowed(false);
                                        },
                                        roles: roles
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).categoriesWrapper,
                        children: [
                            (moreFromTheatre === null || moreFromTheatre === void 0 ? void 0 : moreFromTheatre.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection/* default */.Z, {
                                playlistType: enums/* PlaylistType.Theater */.eX.Theater,
                                title: translations === null || translations === void 0 ? void 0 : translations.theatreMore,
                                plays: moreFromTheatre,
                                moreHref: helpers/* Permalink.theatre */.xm.theatre(play === null || play === void 0 ? void 0 : play.theatre, locale),
                                theater: play === null || play === void 0 ? void 0 : play.theatre.name
                            }),
                            (similarCastPlays === null || similarCastPlays === void 0 ? void 0 : similarCastPlays.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection/* default */.Z, {
                                playlistType: enums/* PlaylistType.SameCast */.eX.SameCast,
                                title: translations === null || translations === void 0 ? void 0 : translations.sameCast,
                                plays: similarCastPlays,
                                moreHref: helpers/* Permalink.sameCast */.xm.sameCast(play, locale),
                                id: play === null || play === void 0 ? void 0 : play.id
                            }),
                            (similarGenresPlays === null || similarGenresPlays === void 0 ? void 0 : similarGenresPlays.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection/* default */.Z, {
                                playlistType: enums/* PlaylistType.SameGenre */.eX.SameGenre,
                                title: translations === null || translations === void 0 ? void 0 : translations.similarGenre,
                                plays: similarGenresPlays,
                                moreHref: helpers/* Permalink.sameGenre */.xm.sameGenre(play, locale),
                                id: play === null || play === void 0 ? void 0 : play.id
                            })
                        ]
                    })
                ]
            }, play.id)
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _playSlug_ = ((0,context/* withForcePlanToLoggedInUnsubs */.DE)(PerformanceDetail));


/***/ }),

/***/ 86145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play":"PlayButton_play__9VaR4","hidden":"PlayButton_hidden__wPqrj"};

/***/ }),

/***/ 28584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"original":"_playSlug__original__LAMoa","playDetail":"_playSlug__playDetail__8jSLB","desktopWrapper":"_playSlug__desktopWrapper__Qf2hT","smallerHeading":"_playSlug__smallerHeading__LspHF","infoWrapper":"_playSlug__infoWrapper__N3ATc","castWrapper":"_playSlug__castWrapper__TD5ZP","notShowed":"_playSlug__notShowed__O2tDv","about":"_playSlug__about__U2JIr","genres":"_playSlug__genres__61JU2","tags":"_playSlug__tags__ydVqd","image":"_playSlug__image__UJiOt","playMeta":"_playSlug__playMeta__VGpmB","time":"_playSlug__time__cBbtb","buttons":"_playSlug__buttons__UqZvG","supportDesktop":"_playSlug__supportDesktop__zfQfd","btnWithIcon":"_playSlug__btnWithIcon__JNKgr","watchList":"_playSlug__watchList__yJLHp","trailer":"_playSlug__trailer__2BlQV","checked":"_playSlug__checked__vcFG3","supportMobile":"_playSlug__supportMobile__Ndy49","theaterLogo":"_playSlug__theaterLogo__9eRDu","lowQualityMobile":"_playSlug__lowQualityMobile__pkDle","lowQualityDesktop":"_playSlug__lowQualityDesktop__sVHjE","lowQuality":"_playSlug__lowQuality__TvNnj","prizes":"_playSlug__prizes__wdrhU","more":"_playSlug__more__XQi8u","categoriesWrapper":"_playSlug__categoriesWrapper__48dGL","noRights":"_playSlug__noRights__6CImu","imageList":"_playSlug__imageList__NZlOr","ommited1":"_playSlug__ommited1__TWS0x","ommited2":"_playSlug__ommited2__E6lOi","ommited3":"_playSlug__ommited3__jrPR3","masonRow":"_playSlug__masonRow__fkMKK","masonCol":"_playSlug__masonCol__XlZN3"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(32223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);